<template>
	<v-card
		:id="packagingType.key"
		style="box-shadow: 0 0 20px 0 #0000001A;"
		class="text-center d-flex flex-column justify-center"
		@click="selectPackagingType(packagingType)"
		@touchend="selectPackagingType(packagingType)"
		:disabled="selecting"
		height="12rem"
		width="14rem"
	>
		<div style="padding: 1rem;">
			<v-icon :icon="packagingType.icon" size="4.5rem" />
		</div>
		<div
				style="font-size: 1.5rem; font-weight: 700; padding: 1rem;"
		>
			{{ t(packagingType.label) }}
		</div>
	</v-card>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useStore } from '../../stores/store';

export default {
	name: "PackagingCard",
	props: {
		packagingType: {
			type: Object,
			default: null
		}
	},
	setup() {
		const store = useStore()
		const { t, te } = useI18n()

		return {
			store,
			te,
			t
		}
	},
	data() {
		return {
			selecting: false
		}
	},
	methods: {
		async selectPackagingType(type) {			
			this.selecting = true

			await this.store.fetchAndUpdateLocationBlocks()
				

				setTimeout(() => {
					this.store.updateSessionStartTime()
					this.store.selectPackaging(type)
					this.selecting = false
					}, 100)
					this.store.customLogger('info', 'Selected Order Fulfillment', type)
			
		},
	}
}
</script>

<style scoped>

</style>